module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "customClass": 'heightAuto',
      "footer": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("New service")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('extra-form', {
    on: {
      "toggleIsDisabled": _vm.toggleIsDisabled,
      "readyToSave": _vm.readyToSave
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-all",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok wider",
    attrs: {
      "type": "button",
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-3e87e352", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e87e352"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ExtraAdd.vue
// module id = 968
// module chunks = 0